@if (shipment) {
  <div class="details">
    <div class="details__column">
      @if (shipment.parties.shipper) {
        <div class="details__column--label">Shipper</div>
        <span>{{ shipment.parties.shipper.name }}</span>
        @if (shipment.parties.shipper.country) {
          <div>{{ shipment.parties.shipper.country }}</div>
        }
      }
    </div>
    <div class="details__column">
      @if (shipment.parties.consignee) {
        <div class="details__column--label">Consignee</div>
        <span>{{ shipment.parties.consignee.name }}</span>
        @if (shipment.parties.consignee.country) {
          <div>{{ shipment.parties.consignee.country }}</div>
        }
      }
    </div>
    @if (shipment.goodsSummary) {
      <div class="details__column--full">
        <div class="details__column--label">Goods Summary</div>
        <div>
          @if (shipment.goodsSummary.totalPackages > 0) {
            <span class="details__column--value">{{ shipment.goodsSummary.totalPackages }} CLL</span>
          }

          @if (shipment.goodsSummary.totalWeightInKg > 0) {
            <span class="details__column--value">{{ shipment.goodsSummary.totalWeightInKg }} KG</span>
          }

          @if (shipment.goodsSummary.totalVolumeInCbm > 0) {
            <span class="details__column--value"
              >{{ shipment.goodsSummary.totalVolumeInCbm | number: '1.0-3' : 'de-DE' }} CBM</span
            >
          }

          @if (shipment.goodsSummary.totalLdm > 0 && shipment.transportMode === 'Road') {
            <span class="details__column--value"
              >{{ shipment.goodsSummary.totalLdm | number: '1.0-2' : 'de-DE' }} LDM</span
            >
          }
        </div>
      </div>
    }

    <div class="details__column">
      @if (shipment.shipmentType) {
        <div class="details__column--label">Shipment Type</div>
        <span>{{ shipment.shipmentType }}</span>
      }
    </div>

    <div class="details__column">
      @if (shipment.shipmentService) {
        <div class="details__column--label">Shipment Service</div>
        <span>{{ shipment.shipmentService }}</span>
      }
    </div>

    <div class="details__column--full">
      @if (shipment.references | hasReferences) {
        <div class="details__column--label">References</div>
        @for (re of shipment.references; track index; let index = $index) {
          @if (re) {
            <div>{{ re }}</div>
          }
        }
      }
    </div>

    <div class="details__column">
      @switch (shipment.transportMode) {
        @case ('Air') {
          <div class="details__column--label">HAWB</div>
          <span>{{ shipment.houseNo }}</span>
        }
        @case ('Ocean') {
          <div class="details__column--label">HBL</div>
          <span>{{ shipment.houseNo }}</span>
        }
        @case ('Rail') {
          <div class="details__column--label">HBL</div>
          <span>{{ shipment.houseNo }}</span>
        }
        @case ('Courier') {
          <div class="details__column--label">Track and trace</div>
          @if (shipment.routing.carrierName | courierTrackingLinks: shipment.masterNo; as trackingLink) {
            <a [href]="trackingLink" target="_blank">{{ shipment.masterNo }}</a>
          } @else {
            <span>--</span>
          }
        }
      }
    </div>

    <div class="details__column">
      @if (shipment.transportMode === 'Air') {
        <div class="details__column--label">AWB</div>
        <span>{{ shipment.masterNo }}</span>
      }
    </div>

    <div class="details__column--full">
      @if (shipment.shipmentNo) {
        <div class="details__column--label">Sgl Shipment no.</div>
        <span>{{ shipment.shipmentNo }}</span>
      }
    </div>
  </div>
} @else {
  <app-details-skeleton></app-details-skeleton>
}
